module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('button', {
    staticClass: "btn",
    class: [_vm.btnType, {
      'btn-unbg': !!_vm.unbg,
      'btn-border': !!_vm.border,
      'btn-block': !!_vm.block
    }, _vm.btnSize],
    attrs: {
      "type": _vm.eltag
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(!!_vm.icon) ? _c('span', {
    staticClass: "iconfont",
    class: [_vm.icon]
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-33ab297a!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/form/btn.vue
// module id = 305
// module chunks = 2